import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Input from '@mui/material/Input';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/VisibilityOutlined';
import VisibilityOff from '@mui/icons-material/VisibilityOffOutlined';

import axios from 'api/axios';
import Login from './Login.js';
const PASSWORD_RESET_URL = 'users/password';

const SetNewPassword = () => {

  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);

  const location = useLocation();
  const from = location.state?.from?.pathname || "/SetNewPasswordDone";

  const errRef = useRef();
  const pwd1Ref = useRef();
  const pwd2Ref = useRef();

  const [pwd1, setPwd1] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConf, setShowPasswordConf] = useState(false);

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{12,}$/;

  const token = queryParams.get('token');

  useEffect(() => {
    pwd1Ref.current.focus();
    setErrMsg('');
  }, []);

  const handleMouseUpPassword = (event) => event.preventDefault();
  const handleMouseDownPassword = (event) => event.preventDefault();
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPasswordConf = () => setShowPasswordConf((show) => !show);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passwordRegex.test(pwd1)) {
      setErrMsg('Le mot de passe doit contenir au moins 12 caractères, incluant une majuscule, une minuscule, un chiffre et un caractère spécial.');
      return;
    }
  
    if (pwd1 !== pwd2) {
      setErrMsg('Les deux mots de passe ne correspondent pas.');
      return;
    }

    //The two password fields match and the regex is OK
    try {
      await axios.patch(PASSWORD_RESET_URL,
        JSON.stringify({ token: token, password: pwd1, password_confirmation: pwd2 }),
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Invalid Token or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Invalid Token or Password');
      } else if (err.response?.status === 422) {
        if (err?.response?.data?.password[0]) setErrMsg(err?.response?.data?.password[0]);
        else setErrMsg('Invalid Token or Password');
      } else {
        setErrMsg('Server Failed');
      }
      errRef.current.focus();
    }
  }
  


  return (
    <Login>
      <div className="Login-formulaire">
        <form onSubmit={handleSubmit}>
          <div ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</div>
          <p className="Login-info">Veuillez définir votre nouveau mot de passe ci-dessous.</p>

          <div className="Login-field password"><span>*</span> Mot de passe</div>
          <Input
            required
            value={pwd1}
            inputRef={pwd1Ref}
            id="Login-password"
            disableUnderline={true}
            className="Login-input password"
            onChange={(e) => setPwd1(e.target.value)}
            type={showPassword ? 'text' : 'password'}
            startAdornment={
              <InputAdornment position="start">
                <LockOutlinedIcon fontSize="small" style={{ color: '#326ea0' }} />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  aria-label={
                    showPassword ? 'cacher le mot de passe' : 'afficher le mot de passe'
                  }
                  onClick={handleClickShowPassword}
                  onMouseUp={handleMouseUpPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                </IconButton>
              </InputAdornment>
            }
          />

          <div className="Login-field password"><span>*</span> Confirmation du mot de passe</div>
          <Input
            required
            value={pwd2}
            inputRef={pwd2Ref}
            id="Login-password-conf"
            disableUnderline={true}
            className="Login-input password"
            onChange={(e) => setPwd2(e.target.value)}
            type={showPassword ? 'text' : 'password'}
            startAdornment={
              <InputAdornment position="start">
                <LockOutlinedIcon fontSize="small" style={{ color: '#326ea0' }} />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  aria-label={
                    showPasswordConf ? 'cacher le mot de passe' : 'afficher le mot de passe'
                  }
                  onMouseUp={handleMouseUpPassword}
                  onMouseDown={handleMouseDownPassword}
                  onClick={handleClickShowPasswordConf}
                >
                  {showPasswordConf ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                </IconButton>
              </InputAdornment>
            }
          />

          <button className="Login-rectangle-button" onSubmit={handleSubmit}>Enregistrer le mot de passe</button>
        </form>
      </div>
    </Login>
  );
}

export default SetNewPassword;
